import { useEffect } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Modal from "../../modal/Modal";
import { useBenchmarkingDisclaimerManager } from "./BenchmarkingDisclaimerTrigger.functions";

import "./BenchmarkingDisclaimerTrigger.css";

/// props validation | SQ(javascript:S6774)
BenchmarkingDisclaimerTrigger.propTypes = {
  user: PropTypes.object.isRequired,
};
///
function BenchmarkingDisclaimerTrigger({ user }) {
  const [manager] = useBenchmarkingDisclaimerManager({ user });

  const { disclaimerAccepted, setShow } = manager;

  useEffect(() => {
    if (!disclaimerAccepted) {
      setShow(true);
    }
  }, [disclaimerAccepted, setShow]);

  return (
    <div className="benchmarking-disclaimer-trigger">
      <ButtonWithModal {...manager} />
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
ButtonWithModal.propTypes = {
  buttonLabel: PropTypes.any,
  buttonClassName: PropTypes.string,
  onClick: PropTypes.func,
  ModalComponent: PropTypes.func,
  label: PropTypes.any,
  show: PropTypes.bool,
  setShow: PropTypes.func,
};
///
export function ButtonWithModal(props) {
  const { buttonLabel, buttonClassName, onClick } = props;
  const { label, ModalComponent, show, setShow } = props;

  return (
    <>
      <button className={buttonClassName} onClick={onClick}>
        {buttonLabel}
      </button>
      <Modal
        Component={ModalComponent}
        modal={show}
        setModal={setShow}
        title={label}
        {...props}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  user: state.auth.user, // Assuming the user info is stored under state.auth.user
});

export default connect(mapStateToProps)(BenchmarkingDisclaimerTrigger);
